import {
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
  useTheme,
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

import ThickCloseIcon from './ThickCloseIcon';
import {
  closeButton,
  headerBox,
  thickCloseIcon,
  titleText,
  mainText,
  subTextStyle,
  closeActionButton,
} from './styles';

import CustomDialogModal from '../Custom';

const ErrorDialogModal = ({
  isOpen,
  onClose,
  title,
  message,
  subText,
  closeText = 'Aceptar',
}) => {
  const theme = useTheme();

  const handleClose = () => {
    onClose?.();
  };

  return (
    <CustomDialogModal open={isOpen} onClose={handleClose}>
      {/* Botón cerrar mobile */}
      <IconButton
        onClick={handleClose}
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          color: 'red',
          ...closeButton,
        }}
      >
        <CancelIcon sx={{ fontSize: { xs: 22, sm: 30 } }} />
      </IconButton>

      {/* Header */}

      <Box sx={headerBox}>
        <ThickCloseIcon sx={thickCloseIcon(theme)} />
        <Typography sx={titleText}>{title}</Typography>
      </Box>

      {/* Contenido */}
      <DialogContent
        sx={{
          px: 0,
          pt: 0,
          pb: 0,
          maxHeight: { xs: 'calc(100vh - 60px)', sm: 'auto' },
          overflowY: 'auto',
        }}
      >
        <DialogContentText sx={{ ...mainText, mb: 0 }}>
          {message}
        </DialogContentText>
        {subText && <Typography sx={subTextStyle}>{subText}</Typography>}
      </DialogContent>

      {/* Botón inferior */}
      <DialogActions sx={{ justifyContent: 'center', p: 0 }}>
        <Button
          variant="contained"
          onClick={handleClose}
          sx={closeActionButton(theme)}
        >
          {closeText}
        </Button>
      </DialogActions>
    </CustomDialogModal>
  );
};

export default ErrorDialogModal;
